/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Col_AcInputs */

const en_pc_cmp_col_ac = /** @type {(inputs: Pc_Cmp_Col_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe Acrobat`)
};

const zh_pc_cmp_col_ac = /** @type {(inputs: Pc_Cmp_Col_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe Acrobat`)
};

/**
* | output |
* | --- |
* | "Adobe Acrobat" |
*
* @param {Pc_Cmp_Col_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_col_ac = /** @type {((inputs?: Pc_Cmp_Col_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Col_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_col_ac(inputs)
	return zh_pc_cmp_col_ac(inputs)
});
export { pc_cmp_col_ac as "pc.cmp.col_ac" }